exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section[data-v-0a13d84c]{margin-bottom:20px}.section h3[data-v-0a13d84c]{margin:0 0 15px 0;color:#333;font-size:16px;font-weight:600}.full-width[data-v-0a13d84c]{width:100%}.el-input-number.full-width[data-v-0a13d84c]{width:100%}.dialog-footer[data-v-0a13d84c]{text-align:right}.el-table[data-v-0a13d84c]{margin-top:10px}", ""]);

// exports
